<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="goBack()">
        <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ 'Statistics_Tab_Name' | translate }}</ion-title>
    @if (isLoading()) {
      <ion-progress-bar type="indeterminate"></ion-progress-bar>
    }
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <ion-refresher slot="fixed" (ionRefresh)="handleRefresh($event)">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>

  <div class="content-wrapper">

    @if (!!statistics().length) {
      <div class="statistic-wrapper" [class.slide]="!!statistics().length">
        <div class="cards-wrapper">
          @for (statistic of statistics(); track statistic.id || $index) {
            <div class="statistic-card">
              <div class="info">
                <h4 class="name">{{ statistic.title }}</h4>
                <p class="date">{{ statistic.createdAt | date: 'dd.MM.yyyy' }}</p>
              </div>
              <div class="value-chip">
                <span class="tint" [style.backgroundColor]="statistic.color"></span>
                <span class="value" [style.color]="statistic.color">{{ statistic.value }}</span>
                <span class="unit" [style.color]="statistic.color">{{ statistic.unit }}</span>
              </div>
            </div>
          }
        </div>
      </div>
    }

    @if (!isLoading() && !statistics().length) {
      <h2 class="no-items">
        <ion-icon name="mail-open-outline"></ion-icon>
        {{ 'No_statistics' | translate}}
      </h2>
    }

  </div>
</ion-content>